export interface IS1BasicEntity {
  id?: string,
  stato: S1State
}

export enum S1State {
  enabled = "ENABLED",
  disabled = "DISABLED"
}